import { OrganizationRoleType } from "../../autogen/bff-api";

/**
 * The previewable roles with their label keys, shared by the sidebar selector and the global
 * banner. The keys stay extractable through the literal t() calls in useSelectableRoles.
 */
export const viewAsRoleOptions: { role: OrganizationRoleType; labelKey: string }[] = [
  { role: OrganizationRoleType.SourcingCreator, labelKey: "Sourcing Creator" },
  { role: OrganizationRoleType.SourcingViewer, labelKey: "Sourcing Viewer" },
  { role: OrganizationRoleType.ContractCreator, labelKey: "Contract Creator" },
  { role: OrganizationRoleType.ContractViewer, labelKey: "Contract Viewer" },
  { role: OrganizationRoleType.ProjectCreator, labelKey: "Project Creator" },
  { role: OrganizationRoleType.ProjectViewer, labelKey: "Project Viewer" },
];

export const viewAsRoleLabelKey = (role: OrganizationRoleType): string | undefined =>
  viewAsRoleOptions.find((option) => option.role === role)?.labelKey;
